import * as domFns from "react-draggable/build/cjs/utils/domFns";

// this function monkey patches the original matchesSelectorAndParentsTo function
// to safely handle cases where the element or its parents might not support the matchesSelector method
// it will return false if the element or any of its parents do not support the method
function safeMatchesSelectorAndParentsTo(el, selector, baseNode) {
	let node = el;
	while (node) {
		try {
			if (domFns.matchesSelector(node, selector)) return true;
		} catch (e) {
			// optionally log or ignore silently
			console.warn("matchesSelector failed for", node, e);
		}

		if (node === baseNode) break;
		node = node?.parentNode;
	}
	return false;
}

// overwrite the original function
domFns.matchesSelectorAndParentsTo = safeMatchesSelectorAndParentsTo;
